import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const authToken = sessionStorage.getItem('authToken');
  const sessionId = sessionStorage.getItem('sessionId');
  
  // Check if user is authenticated
  const isAuthenticated = authToken && sessionId;
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  // Optional: Validate JWT token expiration (basic check)
  try {
    const tokenPayload = JSON.parse(atob(authToken.split('.')[1]));
    const expirationTime = tokenPayload.exp * 1000; // Convert to milliseconds
    
    if (Date.now() >= expirationTime) {
      // Token expired, clear session and redirect
      sessionStorage.clear();
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    // Invalid token format
    sessionStorage.clear();
    return <Navigate to="/" replace />;
  }
  
  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;